export function intForGrade(grade) {
  if (grade === 'Birth-3') return -2
  if (grade === 'Pre-K') return -1
  if (grade === 'K') return 0
  return parseInt(grade)
}

export function gradeSort(grades) {
  return grades.sort((a, b) => intForGrade(a) - intForGrade(b))
}
